import { useCallback, useMemo } from 'react';
import useRequestConfigs from './useRequestConfigs';
const generateBreadcrumbs = (currentGroup) => {
    let pathAccumulator = '';
    const crumbs = currentGroup?.parents?.map((parent) => {
        pathAccumulator += `/${parent.groupId}`;
        return {
            path: pathAccumulator,
            groupId: parent.groupId,
            breadcrumb: parent.displayName,
        };
    });
    return crumbs || [];
};
const getCurrentGroup = (groups, filterValue) => groups.find((group) => filterValue === group.groupId);
export default function useCioBreadcrumb(props) {
    const { groups, filterValue } = props;
    const { setRequestConfigs } = useRequestConfigs();
    const currentGroup = useMemo(() => getCurrentGroup(groups, filterValue), [groups, filterValue]);
    const breadcrumbs = generateBreadcrumbs(currentGroup);
    const onBreadcrumbClick = useCallback((groupId) => {
        setRequestConfigs({ filterName: 'groupId', filterValue: groupId });
    }, [setRequestConfigs]);
    return { breadcrumbs, currentPage: currentGroup?.displayName, onBreadcrumbClick };
}
